import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";
import PurchaseReportService from "services/PurchaseReportService";

export const purchaseReportSummaryCards = createAsyncThunk(
  "purchase-report/purchaseReportSummaryCards",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportSummaryCards(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportRequestOrderStatusDistribution = createAsyncThunk(
  "purchase-report/purchaseReportRequestOrderStatusDistribution",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportRequestOrderStatusDistribution(
          data,
        );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportPurchaseOrderStatusDistribution = createAsyncThunk(
  "purchase-report/purchaseReportPurchaseOrderStatusDistribution",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportPurchaseOrderStatusDistribution(
          data,
        );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportTopBranches = createAsyncThunk(
  "purchase-report/purchaseReportTopBranches",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportTopBranches(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportTopRequestItems = createAsyncThunk(
  "purchase-report/purchaseReportTopRequestItems",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportTopRequestItems(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportTopSuppliers = createAsyncThunk(
  "purchase-report/purchaseReportTopSuppliers",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportTopSuppliers(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportPaymentSummary = createAsyncThunk(
  "purchase-report/purchaseReportPaymentSummary",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportPaymentSummary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportSupplierDebtSummary = createAsyncThunk(
  "purchase-report/purchaseReportSupplierDebtSummary",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportSupplierDebtSummary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const purchaseReportSupplierDebtList = createAsyncThunk(
  "purchase-report/purchaseReportSupplierDebtList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseReportService.purchaseReportSupplierDebtList(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportPurchaseExcel = createAsyncThunk(
  "purchase-report/exportPurchaseExcel",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await PurchaseReportService.exportExcel(params);
      const url = window.URL.createObjectURL(blob);
      const filename = `Báo cáo công nợ_${moment().format("YYYYMMDD")}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  loadingExport: false,

  summaryCard: {},
  requestOrderStatusDistribution: [],
  purchaseOrderStatusDistribution: [],
  topBranches: [],
  topRequestItems: [],
  topSuppliers: [],
  paymentSummary: {},
  supplierDebtSummary: {},
  supplierDebtList: [],
};

const purchaseReportSlice = createSlice({
  name: "purchase-report",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
      state.loadingExport = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(purchaseReportSummaryCards.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportSummaryCards.fulfilled, (state, action) => {
        state.loading = false;
        state.summaryCard = action.payload;
      })
      .addCase(purchaseReportSummaryCards.rejected, (state) => {
        state.loading = false;
      })

      .addCase(
        purchaseReportRequestOrderStatusDistribution.pending,
        (state) => {
          state.loading = true;
        },
      )
      .addCase(
        purchaseReportRequestOrderStatusDistribution.fulfilled,
        (state, action) => {
          state.loading = false;
          state.requestOrderStatusDistribution = action.payload;
        },
      )
      .addCase(
        purchaseReportRequestOrderStatusDistribution.rejected,
        (state) => {
          state.loading = false;
        },
      )

      .addCase(
        purchaseReportPurchaseOrderStatusDistribution.pending,
        (state) => {
          state.loading = true;
        },
      )
      .addCase(
        purchaseReportPurchaseOrderStatusDistribution.fulfilled,
        (state, action) => {
          state.loading = false;
          state.purchaseOrderStatusDistribution = action.payload;
        },
      )
      .addCase(
        purchaseReportPurchaseOrderStatusDistribution.rejected,
        (state) => {
          state.loading = false;
        },
      )

      .addCase(purchaseReportTopBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportTopBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.topBranches = action.payload;
      })
      .addCase(purchaseReportTopBranches.rejected, (state) => {
        state.loading = false;
      })

      .addCase(purchaseReportTopRequestItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportTopRequestItems.fulfilled, (state, action) => {
        state.loading = false;
        state.topRequestItems = action.payload;
      })
      .addCase(purchaseReportTopRequestItems.rejected, (state) => {
        state.loading = false;
      })

      .addCase(purchaseReportTopSuppliers.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportTopSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.topSuppliers = action.payload;
      })
      .addCase(purchaseReportTopSuppliers.rejected, (state) => {
        state.loading = false;
      })

      .addCase(purchaseReportPaymentSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportPaymentSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentSummary = action.payload;
      })
      .addCase(purchaseReportPaymentSummary.rejected, (state) => {
        state.loading = false;
      })

      .addCase(purchaseReportSupplierDebtSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportSupplierDebtSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.supplierDebtSummary = action.payload;
      })
      .addCase(purchaseReportSupplierDebtSummary.rejected, (state) => {
        state.loading = false;
      })

      .addCase(purchaseReportSupplierDebtList.pending, (state) => {
        state.loading = true;
      })
      .addCase(purchaseReportSupplierDebtList.fulfilled, (state, action) => {
        state.loading = false;
        state.supplierDebtList = action.payload;
      })
      .addCase(purchaseReportSupplierDebtList.rejected, (state) => {
        state.loading = false;
      })

      .addCase(exportPurchaseExcel.pending, (state) => {
        state.loadingExport = true;
      })
      .addCase(exportPurchaseExcel.fulfilled, (state) => {
        state.loadingExport = false;
      })
      .addCase(exportPurchaseExcel.rejected, (state) => {
        state.loadingExport = false;
      });
  },
});

export const { showLoading } = purchaseReportSlice.actions;

export default purchaseReportSlice.reducer;
